var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element
    ? _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.element.options.attrs.default,
                "label-width": "100px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("dynamic_time.set_default") } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.dynamicChange },
                      model: {
                        value: _vm.element.options.attrs.default.isDynamic,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.element.options.attrs.default,
                            "isDynamic",
                            $$v
                          )
                        },
                        expression: "element.options.attrs.default.isDynamic",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v(_vm._s(_vm.$t("dynamic_time.fix"))),
                      ]),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v(_vm._s(_vm.$t("dynamic_time.dynamic"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.element.options.attrs.default.isDynamic
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("dynamic_time.relative") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "relative-time",
                          attrs: {
                            placeholder: "",
                            "popper-class": "date-filter-poper",
                          },
                          on: { change: _vm.dkeyChange },
                          model: {
                            value: _vm.element.options.attrs.default.dkey,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.element.options.attrs.default,
                                "dkey",
                                $$v
                              )
                            },
                            expression: "element.options.attrs.default.dkey",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.cweek"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.cmonth"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.cquarter"),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.cyear"),
                              value: 3,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.lweek"),
                              value: 5,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_month.last"),
                              value: 6,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.lquarter"),
                              value: 7,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_year.last"),
                              value: 8,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("dynamic_time.custom"),
                              value: 4,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "inline-first" },
                [
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("dataset.start_time") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { "min-width": "80px", width: "auto" },
                            attrs: {
                              "controls-position": "right",
                              size: "mini",
                              min: 0,
                              max: 100,
                            },
                            on: { change: _vm.sDynamicPrefixChange },
                            model: {
                              value:
                                _vm.element.options.attrs.default
                                  .sDynamicPrefix,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.element.options.attrs.default,
                                  "sDynamicPrefix",
                                  $$v
                                )
                              },
                              expression:
                                "element.options.attrs.default.sDynamicPrefix",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4
                    ? _c(
                        "el-form-item",
                        { staticClass: "no-label-item", attrs: { label: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "min-width": "60px",
                                width: "auto",
                              },
                              attrs: { size: "mini", placeholder: "" },
                              on: { change: _vm.dynamicInfillChange },
                              model: {
                                value:
                                  _vm.element.options.attrs.default
                                    .sDynamicInfill,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.element.options.attrs.default,
                                    "sDynamicInfill",
                                    $$v
                                  )
                                },
                                expression:
                                  "element.options.attrs.default.sDynamicInfill",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.date"),
                                  value: "day",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.week"),
                                  value: "week",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.month"),
                                  value: "month",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.year"),
                                  value: "year",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4
                    ? _c(
                        "el-form-item",
                        { staticClass: "no-label-item", attrs: { label: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "min-width": "60px",
                                width: "auto",
                              },
                              attrs: { size: "mini", placeholder: "" },
                              on: { change: _vm.dynamicSuffixChange },
                              model: {
                                value:
                                  _vm.element.options.attrs.default
                                    .sDynamicSuffix,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.element.options.attrs.default,
                                    "sDynamicSuffix",
                                    $$v
                                  )
                                },
                                expression:
                                  "element.options.attrs.default.sDynamicSuffix",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.before"),
                                  value: "before",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.after"),
                                  value: "after",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4 &&
                  _vm.isTimeWidget &&
                  _vm.element.options.attrs.showTime
                    ? _c(
                        "el-form-item",
                        { staticClass: "no-label-item", attrs: { label: "" } },
                        [
                          _c("el-time-picker", {
                            staticStyle: {
                              width: "auto",
                              "min-width": "110px",
                            },
                            attrs: {
                              "value-format": "timestamp",
                              format: _vm.element.options.attrs.accuracy,
                              placeholder: "",
                            },
                            on: { change: _vm.eDynamicSuffixTimeChange },
                            model: {
                              value:
                                _vm.element.options.attrs.default
                                  .sDynamicSuffixTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.element.options.attrs.default,
                                  "sDynamicSuffixTime",
                                  $$v
                                )
                              },
                              expression:
                                "element.options.attrs.default.sDynamicSuffixTime",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "inline-first" },
                [
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("dataset.end_time") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { "min-width": "80px", width: "auto" },
                            attrs: {
                              "controls-position": "right",
                              size: "mini",
                              min: 0,
                              max: 100,
                            },
                            on: { change: _vm.eDynamicPrefixChange },
                            model: {
                              value:
                                _vm.element.options.attrs.default
                                  .eDynamicPrefix,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.element.options.attrs.default,
                                  "eDynamicPrefix",
                                  $$v
                                )
                              },
                              expression:
                                "element.options.attrs.default.eDynamicPrefix",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4
                    ? _c(
                        "el-form-item",
                        { staticClass: "no-label-item", attrs: { label: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "min-width": "60px",
                                width: "auto",
                              },
                              attrs: { size: "mini", placeholder: "" },
                              on: { change: _vm.dynamicInfillChange },
                              model: {
                                value:
                                  _vm.element.options.attrs.default
                                    .eDynamicInfill,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.element.options.attrs.default,
                                    "eDynamicInfill",
                                    $$v
                                  )
                                },
                                expression:
                                  "element.options.attrs.default.eDynamicInfill",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.date"),
                                  value: "day",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.week"),
                                  value: "week",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.month"),
                                  value: "month",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.year"),
                                  value: "year",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4
                    ? _c(
                        "el-form-item",
                        { staticClass: "no-label-item", attrs: { label: "" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "min-width": "60px",
                                width: "auto",
                              },
                              attrs: { size: "mini", placeholder: "" },
                              on: { change: _vm.dynamicSuffixChange },
                              model: {
                                value:
                                  _vm.element.options.attrs.default
                                    .eDynamicSuffix,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.element.options.attrs.default,
                                    "eDynamicSuffix",
                                    $$v
                                  )
                                },
                                expression:
                                  "element.options.attrs.default.eDynamicSuffix",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.before"),
                                  value: "before",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("dynamic_time.after"),
                                  value: "after",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.element.options.attrs.default.isDynamic &&
                  _vm.element.options.attrs.default.dkey === 4 &&
                  _vm.isTimeWidget &&
                  _vm.element.options.attrs.showTime
                    ? _c(
                        "el-form-item",
                        { staticClass: "no-label-item", attrs: { label: "" } },
                        [
                          _c("el-time-picker", {
                            staticStyle: {
                              "min-width": "110px",
                              width: "auto",
                            },
                            attrs: {
                              "value-format": "timestamp",
                              format: _vm.element.options.attrs.accuracy,
                              placeholder: "",
                            },
                            on: { change: _vm.eDynamicSuffixTimeChange },
                            model: {
                              value:
                                _vm.element.options.attrs.default
                                  .eDynamicSuffixTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.element.options.attrs.default,
                                  "eDynamicSuffixTime",
                                  $$v
                                )
                              },
                              expression:
                                "element.options.attrs.default.eDynamicSuffixTime",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.element.options.attrs.default.isDynamic
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("dynamic_time.preview") } },
                    [
                      _c("el-date-picker", {
                        staticClass: "relative-time",
                        attrs: {
                          type: _vm.componentType,
                          format: _vm.labelFormat,
                          disabled: "",
                          placeholder: "",
                        },
                        model: {
                          value: _vm.dval,
                          callback: function ($$v) {
                            _vm.dval = $$v
                          },
                          expression: "dval",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("dynamic_time.set") } },
                    [
                      _c(_vm.element.component, {
                        tag: "component",
                        staticClass: "relative-time",
                        style: _vm.element.style,
                        attrs: {
                          id: "component" + _vm.element.id,
                          element: _vm.element,
                          "in-draw": false,
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }